import {http} from './self_axios.js'

// 根据RMS节点获取信息
export function getNewsList(payload) {
  // console.log('payload',payload)
  return http({
      url: 'wealth/search',
      method: 'get',
      params:{
      ...payload
      }
  })
}

// 根据RMS ID获取详情
export function getNewsDetail(payload) {
  // console.log('payload',payload)
  return http({
      url: 'wealth/news_detail',
      method: 'get',
      params:{
      ...payload
      }
  })
}

// 根据RMS ID获取视频详情
export function getVideoDetail(payload) {
  // console.log('payload',payload)
  return http({
      url: 'wealth/video_detail',
      method: 'get',
      params:{
        ...payload,
        api_type: 0
      }
  })
}

// 获取课堂列表
export function getEduList(payload) {
  // console.log('payload',payload)
  return http({
    url: 'wealth/edu_classroom',
    method: 'get',
    params:{
    ...payload
    }
  })
}

// 获取互动列表
export function getQaList(payload) {
  // console.log('payload',payload)
  return http({
    url: 'wealth/qa_list',
    method: 'get',
    params:{
    ...payload
    }
  })
}

// 获取热搜资讯
export function getHotNews(payload) {
  // console.log('payload',payload)
  return http({
    url: 'wealth/edu_hot_news',
    method: 'get',
    params:{
      ...payload,
    }
  })
}

// 获取精彩课堂
export function getExcellentClass(payload) {
  // console.log('payload',payload)
  return http({
    //url: 'wealth/edu_excellent_classroom', 
    //20230629需求变动，与 获取课堂列表（首页-课堂取数据一样，首页-课堂取前1-4条，精彩课堂取5-8条）
    url: 'wealth/edu_classroom', 
    method: 'get',
    params:{
      ...payload,
    }
  })
}

// 获取动态二级页列表
export function getDynamicList(payload) {
  // console.log('payload',payload)
  return http({
    url: 'wealth/edu_moments',
    method: 'get',
    params:{
      ...payload,
    }
  })
}

// 获取课堂栏目菜单
export function getCourseTab() {
  // console.log('payload',payload)
  return http({
    url: 'wealth/app_tab_info',
    method: 'get',
    params:{
      api_type:12
    }
  })
}

// 获取课堂栏目菜单
export function getQaDetail(payload) {
  // console.log('payload',payload)
  return http({
    url: 'wealth/qa_detail',
    method: 'get',
    params:{
      ...payload
    }
  })
}